import { render } from "./NavSidebar.vue?vue&type=template&id=0092feb6&scoped=true"
import script from "./NavSidebar.vue?vue&type=script&lang=js"
export * from "./NavSidebar.vue?vue&type=script&lang=js"

import "./NavSidebar.vue?vue&type=style&index=0&id=0092feb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0092feb6"]])

export default __exports__